/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { ConvertDatesToStrings } from '@itk/typescript-utils'
import type { Model_FaqCategoryGet } from '../models/Model_FaqCategoryGet';
import type { Shared_Languages } from '../models/Shared_Languages';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class FaqCategoryService {
    /**
     * @param languageId
     * @returns Model_FaqCategoryGet Success
     * @throws ApiError
     */
    public static getApiV1FaqByLanguageId(
        languageId: ConvertDatesToStrings<Shared_Languages>,
    ): CancelablePromise<Array<Model_FaqCategoryGet>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/faq/byLanguageId',
            query: {
                'languageId': languageId,
            },
        });
    }
}
